// src/Dashboard/admin/layout/MobileSidebar.jsx
import { X } from "lucide-react";

export default function MobileSidebar({
  open,
  onClose,
  logoSrc,
  activeSection,
  onSelectSection,
  navItems = [],
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex md:hidden">
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />

      <aside className="relative z-50 w-72 max-w-[85vw] bg-white dark:bg-slate-900 shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-4 py-4 border-b border-slate-100 dark:border-slate-800">
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={logoSrc}
              alt="VOP Logo"
              className="w-9 h-9 rounded-full object-contain"
            />
            <div className="min-w-0">
              <div className="text-sm font-semibold truncate">VOP Virtual School</div>
              <div className="text-xs text-slate-500 truncate">Admin Portal</div>
            </div>
          </div>

          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 shrink-0"
            aria-label="Close menu"
          >
            <X size={18} />
          </button>
        </div>

        <nav className="flex-1 py-3 space-y-1 overflow-y-auto overflow-x-hidden">
          {navItems.map((item) => {
            if (item.type === "section") {
              return (
                <div
                  key={`msec-${item.label}`}
                  className="px-4 pt-3 pb-1 text-[11px] tracking-wide uppercase text-slate-400 dark:text-slate-500"
                >
                  {item.label}
                </div>
              );
            }

            const Icon = item.icon;
            const isActive = activeSection === item.id;

            return (
              <button
                key={item.id}
                onClick={() => {
                  onSelectSection(item.id);
                  onClose();
                }}
                className={`flex items-center gap-3 w-full min-w-0 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-orange-100/80 text-orange-700 dark:bg-orange-500/20 dark:text-orange-200"
                    : "text-slate-600 dark:text-slate-300 hover:bg-slate-100/80 dark:hover:bg-slate-800/70"
                }`}
              >
                <span className="w-8 flex items-center justify-center shrink-0">
                  <Icon size={20} />
                </span>
                <span className="truncate">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
    </div>
  );
}
